// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".st0[data-v-1cbfcb42]{fill:#0092d0}", "",{"version":3,"sources":["/opt/atlassian/pipelines/agent/build/public/typo3conf/ext/aus_project/Resources/Private/TypeScript/ChatBox/Components/ChatIcon.vue"],"names":[],"mappings":"AAwBA,sBACE,YAAa","file":"ChatIcon.vue?vue&type=style&index=0&id=1cbfcb42&lang=vue-scss&scoped=true&","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.st0 {\n  fill: #0092d0;\n}\n"]}]);
// Exports
module.exports = exports;
